import { lazy } from 'react'
import { withSuspense } from 'utils/lazyLoad/lazyWrapper'

const RegistrationProcess = lazy(() => import('features/registration/pages'))
const AccountPending = lazy(
  () => import('features/registration/components/AccountPending'),
)

const RegistrationRoutes = [
  {
    path: '/registration/process/:id?',
    element: withSuspense(RegistrationProcess),
  },
  { path: '/account/pending', element: withSuspense(AccountPending) },
]

export default RegistrationRoutes
